import { SxStyles } from '../../../../../../types';
import theme from '../../../../../../theme';
import { getResponsiveSize } from '../../../../../../utils';

export const PsylarisListItemStyle: SxStyles = {
  psylarisListItem: {
    mb: getResponsiveSize(4),

    '&.selected': {
      backgroundColor: theme.palette.myPrimary?.lightBlue70,
      borderRadius: '12px',
    },

    '& .list-button': {
      borderRadius: '12px',
      '& .list-icon': {
        color: theme.palette.mainControls?.backText,
      },
      '& .list-text': {
        color: theme.palette.mainControls?.backText,
        fontWeight: '700',
        fontFamily: theme.typography.mainFontFamily,
      },
      '& .list-icon-selected': {
        color: theme.palette.myPrimary?.white,
      },
      '& .list-text-selected': {
        color: theme.palette.myPrimary?.white,
      },
    },
  },
};
